// extracted by mini-css-extract-plugin
export default {"label":"ConfigurationDownload__label___n3Zqp"};